import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ResourceService } from "../../generics/services/generic-http.service";
import { environment } from "../../../environments/environment";
import { User } from "../models/user.model";
import { Observable } from "rxjs";
import { Paginated } from "src/app/generics/models/generic-resource-model";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class UserService extends ResourceService<User> {
  constructor(private http: HttpClient) {
    super(http, User, environment.apiUri + "/user");
  }

  public getAllByPlant<T>(id: number): Observable<T[]> {
    return this.http.get<T[]>(this.apiUrl + `/GetByPlant/${id}`);
  }

  public getUsersByPlantAccess<T>(id: number): Observable<T[]> {
    return this.http.get<T[]>(this.apiUrl + `/GetByPlantAccess/${id}`);
  }

  public getUsersPaginatedByCorporateClient<T>(
    id: number,
    params?:
      | HttpParams
      | any
      | {
          [param: string]:
            | string
            | number
            | boolean
            | readonly (string | number | boolean)[];
        }
  ): Observable<Paginated<T>> {
    return this.http
      .get<T[]>(`${this.apiUrl}/CorporateClient/${id}`, {
        observe: "response",
        params,
      })
      .pipe(
        map((response) => {
          let paged: Paginated<T> = {
            pagination: JSON.parse(response.headers.get("x-pagination")),
            body: response.body,
          };
          return paged;
        })
      );
  }

  public changePassword<T>(body: {
    id: string;
    password: string;
  }): Observable<T> {
    return this.http.put<T>(this.apiUrl + "/password", body);
  }

  public getAll<T>(): Observable<T[]> {
    return this.http.get<T[]>(this.apiUrl + "/all");
  }

  public getAllLegalRepresentative<T>(): Observable<T[]> {
    return this.http.get<T[]>(this.apiUrl + "/legalRepresentative");
  }

  public login<T>(body: {
    email: string;
    password: string;
    deviceIdentifier: string;
  }): Observable<T> {
    return this.http.post<T>(environment.apiUri + "/Auth/login", body);
  }

  public forgotPassword<T>(body: {
    email: string;
    clientUri: string;
  }): Observable<T> {
    return this.http.post<T>(environment.apiUri + "/Auth/ForgotPassword", body);
  }

  public refreshToken<T>(body: {
    email: string;
    refreshToken: string;
    deviceIdentifier: string;
  }): Observable<T> {
    return this.http.post<T>(environment.apiUri + "/auth/Token", body);
  }

  public revokeToken<T>(refreshToken: string): Observable<T> {
    return this.http.post<T>(
      environment.apiUri + `/Auth/RevokeToken/${refreshToken}`,
      null
    );
  }

  public resetPassword<T>(
    token: string,
    body: {
      user: number;
      password: string;
      confirmPassword: string;
      token: string;
    }
  ): Observable<T> {
    return this.http.post<T>(
      environment.apiUri + "/Auth/ResetPassword",
      body,
      {
        headers: { token: token },
        params: new HttpParams().set("tokenQuery", token),
      }
    );
  }

  public tryDelete<T>(shelterID: number): Observable<T[]> {
    return this.http.delete<T[]>(this.apiUrl + `/try/${shelterID}`);
  }

  public validateTokenRecoveryPassword<WU_ResponseHttp>(
    token: string
  ): Observable<WU_ResponseHttp> {
    return this.http.get<WU_ResponseHttp>(
      environment.apiUri + "/Auth/recovery",
      {
        headers: { token: token },
        params: new HttpParams().set("tokenQuery", token),
      }
    );
  }
}
